import React from 'react'

export const Tooltip = React.memo((props) => {
    return (
        <div className='bg-black p-1 pl-2 pr-2 rounded'> <span className='text-xs text-white'>{props?.value}</span></div>
    )
})
